import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { IntlShape } from 'react-intl';
import { computeText } from '@/locales/utils';
import { redirectToBackofficeV1 } from '@/utils/backoffice-v1';

export const UNKNOWN_ERROR_CODE = 'unknown_error_code';

export const getFieldNameFromErrorCode = (errorCode: string): string => {
    switch (errorCode) {
        case 'duplicate_email':
            return 'email';
        case 'duplicate_student_number':
            return 'studentNumber';
        case 'duplicate_badge_number':
            return 'badgeNumber';
        case 'ewallet_is_not_null_to_postpayment':
            return 'accountPaymentType';
        default:
            return UNKNOWN_ERROR_CODE;
    }
};

type FormErrorData = {
    code?: string;
    message?: string;
};

export const getFormErrorInfo = (error: FetchBaseQueryError, intl: IntlShape) => {
    const errorData = (error.data as FormErrorData | undefined) ?? {};
    const fieldName = errorData.code ? getFieldNameFromErrorCode(errorData.code) : UNKNOWN_ERROR_CODE;
    // For known error codes we use the `field.<code>` i18n key (localized per
    // locale). For unmapped codes we fall back to the server-provided `message`,
    // which the API already returns localized, so the user still sees a clear
    // error instead of a silently swallowed one.
    const hasKnownCode = fieldName !== UNKNOWN_ERROR_CODE;
    const message = hasKnownCode ? computeText(intl, `field.${errorData.code}`) : errorData.message ?? '';
    return {
        name: fieldName,
        message,
    };
};

export const generateBadgeNumber = (): string => {
    return String(Math.floor(Math.random() * 100000000));
};

export const redirectToCustomerDetailsPage = (customerId: number): void => {
    const customerDetailsPagePath = `/home/customers/${customerId}/info`;
    redirectToBackofficeV1(customerDetailsPagePath);
};
